import { colorPalette } from '../../colorPalette';
export const filterContainerStyle = {
    width: 'auto',
};
export const titleFilterStyle = {
    '& h3': {
        margin: '0 0 8px 0',
        fontSize: '14px',
        fontWeight: 600,
        color: colorPalette.gray900,
    },
};
export const selectFilterMenuStyle = {
    '&#popoverFilterDates': {
        marginTop: '50px',
    },
};
export const validationFilterButton = {
    marginTop: '12px',
};
/*** Papers style */
const paperStyle = {
    padding: '12px',
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
    borderRadius: '8px',
};
export const datePickerPaperStyle = Object.assign({}, paperStyle);
export const selectFilterPaperStyle = Object.assign(Object.assign({}, paperStyle), { minWidth: '220px !important' });
/*** Filter chip */
export const filterIconChipStyle = {
    /** Override style of Mui-Chip */
    color: `${colorPalette.gray500} !important`,
};
/*** Error message */
export const errorStyles = {
    color: colorPalette.red800,
    mt: 1,
};
